import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionSummaryCards = ({ summaryData }) => {
  const cards = [
    {
      title: 'Total Volume',
      value: summaryData?.totalVolume,
      subtitle: 'This Month',
      icon: 'DollarSign',
      trend: summaryData?.volumeTrend,
      color: 'text-primary'
    },
    {
      title: 'Success Rate',
      value: `${summaryData?.successRate}%`,
      subtitle: 'Last 30 Days',
      icon: 'TrendingUp',
      trend: summaryData?.successTrend,
      color: 'text-success'
    },
    {
      title: 'Pending Review',
      value: summaryData?.pendingReview,
      subtitle: 'Awaiting Action',
      icon: 'Clock',
      trend: null,
      color: 'text-warning'
    },
    {
      title: 'Total Transactions',
      value: summaryData?.totalTransactions,
      subtitle: 'All Time',
      icon: 'Activity',
      trend: summaryData?.transactionTrend,
      color: 'text-secondary'
    }
  ];

  const getTrendIcon = (trend) => {
    if (!trend) return null;
    return trend > 0 ? 'TrendingUp' : 'TrendingDown';
  };

  const getTrendColor = (trend) => {
    if (!trend) return '';
    return trend > 0 ? 'text-success' : 'text-error';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {cards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-10 h-10 rounded-lg bg-muted flex items-center justify-center ${card?.color}`}>
              <Icon name={card?.icon} size={20} />
            </div>
            {card?.trend !== null && (
              <div className={`flex items-center space-x-1 ${getTrendColor(card?.trend)}`}>
                <Icon name={getTrendIcon(card?.trend)} size={16} />
                <span className="text-sm font-medium">
                  {Math.abs(card?.trend)}%
                </span>
              </div>
            )}
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">
              {card?.value}
            </h3>
            <p className="text-sm text-muted-foreground">{card?.title}</p>
            <p className="text-xs text-muted-foreground mt-1">{card?.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TransactionSummaryCards;